import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { IoMdClose } from "react-icons/io";
import img7 from "../../../Assets/logo/logo.png";
import img8 from "../../../Assets/Homeimgs/java.png";
import img9 from "../../../Assets/Homeimgs/node.png";
import img10 from "../../../Assets/Homeimgs/python.png";
import img11 from "../../../Assets/Homeimgs/ai.png";
import img12 from "../../../Assets/Homeimgs/ui-ux.png";
import img13 from "../../../Assets/Homeimgs/dsa.png";

const AppointmentModal = ({ onClose }) => {
  const modalRef = useRef();
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
  });
  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      onClose();
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formValues.name.trim()) newErrors.name = "First Name is required";
    if (!formValues.email.trim()) newErrors.email = "Email is required";
    if (!formValues.phone.trim()) newErrors.phone = "Phone Number is required";
    if (!formValues.city.trim()) newErrors.city = "City is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg("");

    if (!validateForm()) return;

    setLoading(true);
    emailjs
      .sendForm(
        "service_xyvcc1e",
        "template_voinpgp",
        formRef.current,
        "z7shN8aJoJopttBxt"
      )
      .then((result) => {
        console.log(result.text);
        setLoading(false);
        formRef.current.reset();
        setFormValues({ name: "", email: "", phone: "", city: "" });
        setErrors({});
        setSuccessMsg("Thank you! We'll contact you shortly.");
      })
      .catch((error) => {
        console.error(error.text);
        setLoading(false);
      });
  };

  return (
    <div
      ref={modalRef}
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4 sm:p-6"
      onClick={closeModal}
    >
      <div className="relative w-full max-w-5xl overflow-hidden rounded-3xl shadow-2xl border border-[#5989C8]/20 bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white flex flex-col lg:flex-row">
        <div className="pointer-events-none absolute -top-24 -left-24 h-48 w-48 rounded-full bg-[#064585]/20 blur-3xl" />
        <div className="pointer-events-none absolute bottom-0 -right-24 h-64 w-64 rounded-full bg-[#5989C8]/25 blur-3xl" />

        <div className="relative hidden lg:flex flex-col w-[40%] p-6 lg:p-8 gap-4 border-r border-white/40">
          <h2 className="text-xl lg:text-2xl font-semibold text-[#064585]">
            “Web_Bocket Classes boosts careers with skills, mentorship &
            placements.”
          </h2>
          <p className="text-sm text-slate-700">
            Learn job-ready skills, build real-world projects, and get guided
            support to become a Software Developer Intern.
          </p>

          <div className="grid grid-cols-2 gap-3 mt-3">
            {[img9, img8, img10, img11, img13, img12].map((img, idx) => (
              <div
                key={idx}
                className="bg-white/80 backdrop-blur rounded-2xl shadow-sm flex items-center justify-center p-3"
              >
                <img
                  src={img}
                  alt="tech"
                  className="w-14 h-14 object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="relative w-full lg:w-[60%] bg-white/80 backdrop-blur p-5 sm:p-7 lg:p-8 flex flex-col justify-center">
          {/* Close button */}
          <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-3 text-slate-600 hover:text-black transition"
          >
            <IoMdClose size={22} />
          </button>

          <div className="flex items-center gap-3 mb-4">
            <img src={img7} alt="Web_Bocket Logo" className="w-12 h-12" />
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-[#064585]">
                Want To Become A Software Developer Intern?
              </h2>
              <p className="text-xs md:text-sm text-slate-600">
                Share your details to get course updates & internship
                information.
              </p>
            </div>
          </div>

          {/* Form */}
          <form ref={formRef} onSubmit={handleSubmit} className="w-full">
            <div className="space-y-4 sm:space-y-5 mt-4">
              <div>
                <input
                  type="text"
                  className="w-full border border-gray-300 bg-white/70 p-3 rounded-xl text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
                  placeholder="First Name"
                  name="name"
                  value={formValues.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                )}
              </div>

              <div>
                <input
                  type="email"
                  className="w-full border border-gray-300 bg-white/70 p-3 rounded-xl text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
                  placeholder="Email"
                  name="email"
                  value={formValues.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                )}
              </div>

              <div>
                <input
                  type="tel"
                  className="w-full border border-gray-300 bg-white/70 p-3 rounded-xl text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
                  placeholder="Phone Number"
                  name="phone"
                  value={formValues.phone}
                  onChange={handleChange}
                />
                {errors.phone && (
                  <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                )}
              </div>

              <div>
                <input
                  type="text"
                  className="w-full border border-gray-300 bg-white/70 p-3 rounded-xl text-sm md:text-base focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
                  placeholder="City"
                  name="city"
                  value={formValues.city}
                  onChange={handleChange}
                />
                {errors.city && (
                  <p className="text-red-500 text-xs mt-1">{errors.city}</p>
                )}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-2">
                <button
                  className="bg-gradient-to-r from-[#5989C8] to-[#064585] text-white px-6 md:px-8 py-2.5 rounded-full text-sm md:text-base font-medium shadow-md hover:shadow-lg transition disabled:opacity-70 disabled:cursor-not-allowed"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Submit"}
                </button>

                {successMsg && (
                  <p className="text-xs md:text-sm text-green-600">
                    {successMsg}
                  </p>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AppointmentModal;
